<template>
  <div class="ming-date-pick">
    <!-- 头部 -->
    <div class="date-head">
      <span>{{ showDate }}</span>
      <div class="btn-group">
        <el-button    icon="el-icon-arrow-left" circle @click="preFun" />
        <el-button    icon="el-icon-arrow-right" circle @click="nextFun" />
      </div>
    </div>
    <!-- 周 -->
    <ul class="weeks">
      <li v-for="week in weeks" :key="week">{{ week }}</li>
    </ul>
    <div class="box">
      <ul v-for="(item, index) in initDate" :key="index" class="month-day">
        <li
          v-for="day in item"
          :key="day.fullDate"
          :title="day.fullDate"
          :class="[...day.class, hasCourseDate.includes(day.fullDate) ? 'hasCourse' : '', day.fullDate === currentActive ? 'active' : '']"
          @click="selectDate(day)"
        >
          <span>{{ day.fullDate === curdFormat ? '今' : day.date }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import moment from '@/utils/moment'

const props = defineProps({
  includes: {
    type: Array,
    default: () => []
  }
})

const hasCourseDate = computed(() => {
  return props.includes
})

const emit = defineEmits(['complated', 'monthChange'])

const currentMonth = ref('')

const weeks = ref(['一', '二', '三', '四', '五', '六', '日'])
const initDate = ref([])
const today = moment()
// const monthShow = ref()

const curdFormat = moment().format('YYYY-MM-DD')

// 当月多少天
const getMonthDays = momentObj => {
  return momentObj.daysInMonth()
}

// 当月第一天是周几
const getWeekDays = momentObj => {
  return momentObj.startOf('month').weekday()
}

const MonthYearMonth = (momentObj, key) => {
  return momentObj.subtract(key, 'months').format('YYYY-MM')
}
const showDate = ref('')

const setDate = m => {
  // 上个月
  const lastMonth = ref([])
  const nextMonth = ref([])
  const currMonth = ref([])
  initDate.value = []
  const curDays = getMonthDays(m)
  // 当月第一天是星期几
  const curWeek = getWeekDays(m.clone())
  // 定义一下上个月的总天数
  const upDays = ref(getMonthDays(m.clone().subtract(1, 'month')))

  showDate.value = m.format('YYYY年MM月')
  currentMonth.value = m.format('YYYY-MM')
  // const curMonth = m.format('MM')
  // const curYear = m.format('YYYY')
  // const currDay = m.format('DD')
  const nextFirstDate = ref(0)
  // 整个日历显示的天数   5行  一行七天  共35天
  const calendarRow = ref(35)

  for (let index = 0; index < calendarRow.value; index++) {
    if (index < curWeek) {
      lastMonth.value.unshift({
        date: upDays.value,
        fullDate: MonthYearMonth(m.clone(), 1) + '-' + upDays.value,
        class: ['prev']
      })
      --upDays.value
    } else if (index >= curDays + curWeek) {
      nextFirstDate.value++
      nextMonth.value.push({
        date: nextFirstDate.value,
        fullDate: MonthYearMonth(m.clone(), 2) + '-' + nextFirstDate.value,
        class: ['next']
      })
    } else {
      // 当月要显示的日期
      let c = index - curWeek + 1
      c = +c < 10 ? '0' + c : c
      const fullDate = MonthYearMonth(m.clone(), 0) + '-' + c
      currMonth.value.push({
        date: c,
        fullDate: fullDate,
        class: curdFormat === '' + fullDate ? ['today', 'current'] : ['current']
      })
    }
  }

  const arr = [...lastMonth.value, ...currMonth.value, ...nextMonth.value]
  for (var i = 0, len = arr.length; i < len; i += 7) {
    initDate.value.push(arr.slice(i, i + 7))
  }
}

// 切换上一月
const preFun = () => {
  initDate.value = []
  currentActive.value = ''
  setDate(today.subtract(1, 'month'))
  emit('monthChange', currentMonth.value)
}
// 切换下一月
const nextFun = () => {
  initDate.value = []
  currentActive.value = ''
  setDate(today.add(1, 'month'))
  emit('monthChange', currentMonth.value)
}

const currentActive = ref('')

// 选择日期
const selectDate = data => {
  const formatData = {
    ...data,
    formatDate: moment(data.fullDate).format('YYYY年MM月DD日')
  }
  if (data.class.includes('prev')) {
    setDate(today.subtract(1, 'month'))
  }
  if (data.class.includes('next')) {
    setDate(today.add(1, 'month'))
  }
  if (data.fullDate === curdFormat) {
    currentActive.value = ''
  } else {
    currentActive.value = data.fullDate
  }
  emit('complated', formatData)
}

onMounted(() => {
  setDate(today)
  setTimeout(() => {
    initDate.value.forEach(item => {
      item.forEach(citem => {
        if (citem.fullDate === curdFormat) {
          selectDate(citem)
        }
      })
    })
  }, 1000)
})
</script>

<style lang="scss" scoped>
.ming-date-pick {
  .date-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 0 10px;
    span {
      font-size: 18px;
    }
  }
  .weeks {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
    padding: 0;
    li {
      flex: 1;
      // height: 41px;
      display: flex;
      justify-content: center;
      list-style: none;
      color: #888;
    }
  }
  .month-day {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    margin-top: 10px;
    &:not(:last-child) {
      margin-bottom: 5px;
    }
    li {
      list-style: none;
      flex: 1;
      // height: 40px;
      cursor: pointer;
      span {
        display: flex;
        // width: 39px;
        // height: 39px;
        width: 33px;
        height: 33px;
        margin: 0 auto;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        transition: all linear 0.3s;
        &:hover {
          background-color: #ddd;
          color: #fff;
        }
      }
    }
  }
}
.current {
  span {
    color: #333;
  }
}
.today {
  span {
    background-color: rgb(197.7, 225.9, 255);
    color: var(--theme-color);
    font-weight: bold;
  }
}
.prev,
.next {
  span {
    color: #999;
  }
}

.active {
  span {
    background-color: var(--theme-color);
    color: #fff;
  }
}

.hasCourse {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    display: block;
    width: 6px;
    height: 6px;
    background: var(--theme-color);
    border-radius: 50%;
    left: 50%;
    margin-left: -3px;
  }
}
</style>
